import { render, staticRenderFns } from "./ShareSet.vue?vue&type=template&id=26206bcd&"
import script from "./ShareSet.vue?vue&type=script&lang=js&"
export * from "./ShareSet.vue?vue&type=script&lang=js&"
import style0 from "./ShareSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports